import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import Marquee from "@/components/Marquee";

const About = () => (
  <div data-testid="about-page" className="bg-ivory">
    <section className="border-b border-line py-16 md:py-24 text-center">
      <Reveal>
        <p className="eyebrow">About Merari</p>
        <h1 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight">More Than a Candle</h1>
      </Reveal>
    </section>
    <Marquee />
    <section className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20 py-20 md:py-28 grid gap-16 lg:grid-cols-2 items-start">
      <Reveal>
        <div className="border border-line bg-white p-3">
          <div className="aspect-[4/5] overflow-hidden" data-testid="founder-photo">
            <img src="/assets/founder.png" alt="Merari Torres, founder of Merari Candle Company" className="h-full w-full object-cover object-top" />
          </div>
        </div>
        <p className="mt-4 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-stone2">Merari Torres · Founder</p>
      </Reveal>
      <Reveal delay={0.15}>
        <h2 className="font-serif text-3xl sm:text-4xl font-light tracking-tight">Meet the Founder</h2>
        <div className="mt-8 space-y-6 text-sm md:text-base leading-relaxed text-stone2">
          <p>Hi, I'm Merari Torres, founder of Merari Candle Company, based in Pennsylvania.</p>
          <p>
            My love for beautiful scents began at a young age. Whether it was a lovely perfume or the comforting glow of a candle, I've always loved the way fragrance can change the feeling of a space.
          </p>
          <p>
            The idea for Merari Candle Company was born right in my living room, when I decided to make my very first candle. I chose a fresh, clean scent — and from that simple moment, something special began.
          </p>
          <p>
            Today, I create candles with clean, inviting fragrances designed to make your home feel warm, peaceful, and welcoming from the moment you light the wick.
          </p>
          <p>
            Every candle is created with love, with the hope that it brings a little more comfort and beauty into your home.
          </p>
          <p className="font-serif text-2xl italic font-light text-ink pt-2">— Merari Torres, Founder</p>
        </div>
        <div className="mt-10 grid grid-cols-3 gap-px border border-line bg-line">
          {[["100%", "Soy Wax"], ["Small", "Batch Pours"], ["9 oz", "Signature Pour"]].map(([a, b]) => (
            <div key={b} className="bg-white px-4 py-6 text-center">
              <p className="font-serif text-2xl font-light">{a}</p>
              <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.25em] text-stone2">{b}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/shop" data-testid="about-shop-link" className="btn-primary">Shop Candles</Link>
          <Link to="/experience" data-testid="about-experience-link" className="btn-outline">The Experience</Link>
        </div>
      </Reveal>
    </section>
  </div>
);

export default About;
